import { FC, ReactNode } from 'react'
import { Toaster } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'

import { emptySelector, sidebarSelector } from '@/core/services/App/AppSelector'
import { useAppSelector } from '@/core/store/hooks'
import { userSelector } from '@/modules/Auth/store/AuthSelector'
import { cn } from '@bem-react/classname'

import { Exchange } from '@/components/UI/Exchange'

import { Footer } from '../Footer'
import { Header } from '../Header'
import { Menu } from '../Menu'
import './Private.scss'

interface IPrivate {
  children: ReactNode
  className?: string
}

const cnPrivate = cn('Private')

export const Private: FC<IPrivate> = ({ children, className }: IPrivate) => {
  const { t } = useTranslation()
  const sidebar = useAppSelector(sidebarSelector)
  const user = useAppSelector(userSelector)
  const empty = useAppSelector(emptySelector)

  return (
    <div className={cnPrivate(null, [className])}>
      <Header className={cnPrivate('header')} />
      <div className={cnPrivate('content')}>
        <div className={cnPrivate('title')}>
          {t('private-username', {
            username: ', ' + user?.full_name || '',
          })}
        </div>
      </div>
      <div className={cnPrivate('content')}>
        <Menu className={cnPrivate('menu')} />
        <div className={cnPrivate('children', { empty })}>{children}</div>

        {sidebar ? (
          <div className={cnPrivate('sidebar')}>{sidebar}</div>
        ) : (
          <Exchange className={cnPrivate('sidebar')} />
        )}
      </div>

      <Footer className={cnPrivate('footer')} />
      <Toaster />
    </div>
  )
}
